// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment web-sidebar-grouped-history --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useWebSidebarGroupedHistoryVariation = makeBooleanFlagValueHook('web-sidebar-grouped-history');
//# sourceMappingURL=useWebSidebarGroupedHistoryVariation.js.map